import { buildProps } from '@zoryn/utils'

import type { ExtractPublicPropTypes } from 'vue'
import type TabPane from './tab-pane.vue'

/**
 * @deprecated Removed after 3.0.0, Use `TabPaneProps` instead.
 */
export const tabPaneProps = buildProps({
  /**
   * @description title of the tab
   */
  label: {
    type: String,
    default: '',
  },
  /**
   * @description identifier corresponding to the name of Tabs, representing the alias of the tab-pane, the default is ordinal number of the tab-pane in the sequence, e.g. the first tab-pane is '0'
   */
  name: {
    type: [String, Number],
  },
  /**
   * @description whether Tab is closable
   */
  closable: {
    type: Boolean,
    default: undefined,
  },
  /**
   * @description whether Tab is disabled
   */
  disabled: Boolean,
  /**
   * @description whether Tab is lazily rendered
   */
  lazy: Boolean,
} as const)

export type TabPaneProps = {
  /**
   * @description title of the tab
   */
  label?: string
  /**
   * @description identifier corresponding to the name of Tabs, representing the alias of the tab-pane, the default is ordinal number of the tab-pane in the sequence, e.g. the first tab-pane is '0'
   */
  name?: string | number
  /**
   * @description whether Tab is closable
   */
  closable?: boolean
  /**
   * @description whether Tab is disabled
   */
  disabled?: boolean
  /**
   * @description whether Tab is lazily rendered
   */
  lazy?: boolean
}

/**
 * @deprecated Removed after 3.0.0, Use `TabPaneProps` instead.
 */
export type TabPanePropsPublic = ExtractPublicPropTypes<typeof tabPaneProps>

export type TabPaneInstance = InstanceType<typeof TabPane> & unknown
